import { OrganisationType } from '@/shared/types/enum';

import { getControl, getEditor } from '@/front/editable/state';
import { listen } from '@/front/event';

const TAX_RETURN_TITLE_SET = 'Tax Return (Final Declaration)';
const TAX_RETURN_TITLE_UNSET = 'Tax Return (Self Assessment)';
const TAX_RETURN_TITLE_DEFAULT = 'Tax Return';

listen('editablesReady', () => {
  [...document.querySelectorAll('.editable[data-field="mtdItStartOn"]')]
    .map((editable) => editable as HTMLDivElement)
    .forEach((editable) => {
      const form = editable.closest('form') as HTMLFormElement | null;
      if (!form) return;

      const titleElement = form.querySelector('[data-tax-return-title="true"]') as HTMLElement | null;
      if (!titleElement) return;

      const organisationTypeEditable = form.querySelector(
        '.editable[data-field="organisationType"]',
      ) as HTMLDivElement | null;

      const getEditableValue = (id: string) => getControl(id)?.value ?? getEditor(id)?.value;

      const supportsMtdTaxReturnTitle = () =>
        !organisationTypeEditable || getEditableValue(organisationTypeEditable.id) === OrganisationType.SoleTrader;

      const updateTitle = (hasValue: boolean) => {
        titleElement.textContent = supportsMtdTaxReturnTitle()
          ? hasValue
            ? TAX_RETURN_TITLE_SET
            : TAX_RETURN_TITLE_UNSET
          : TAX_RETURN_TITLE_DEFAULT;
      };

      const hasMtdItStartOnValue = () => !!getEditableValue(editable.id);

      updateTitle(hasMtdItStartOnValue());

      const editor = getEditor(editable.id);
      if (editor) {
        const originalActionSuccess = editor.actionSuccess;
        editor.actionSuccess = (args) => {
          originalActionSuccess?.call(editor, args);
          updateTitle(!!args.value);
        };
      } else {
        const control = getControl(editable.id);
        if (control) {
          const originalChange = control.change;
          control.change = (...args) => {
            originalChange?.apply(control, args);
            updateTitle(!!control.value);
          };
        }
      }

      const organisationTypeControl = organisationTypeEditable ? getControl(organisationTypeEditable.id) : undefined;
      if (organisationTypeControl) {
        organisationTypeControl.addEventListener('change', () => {
          updateTitle(hasMtdItStartOnValue());
        });
      }
    });
});
